var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.active)?_c('div',{staticClass:"d-sm-flex justify-content-center"},[_c('div',{staticClass:"alert",class:_vm.type,attrs:{"id":"app-alert","role":"alert"}},[_vm._v(_vm._s(_vm.message))])]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }